import React, {useEffect, useState} from 'react';
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import {useDashboard} from "../../../utilities/context/dashboard/dashboard-context";
import useAuthCalls from "../../../utilities/custom-hooks/auth-calls";
import {doCreatePaymentIntent} from "../../../logic/payments";
import CheckoutForm from "../../Payments/CheckoutForm";
import Loading from "../../UI/Loading";
import ErrorMessage from "../../UI/ErrorMessage";
import Row from "../../UI/Row";
import BankTransferData from "./BankTransferData";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const SubscriptionPurchase = ({subscription}) => {

    const {user_id, user} = useDashboard();

    console.log(user);

    const [clientSecret, setClientSecret] = useState("");
    const [loading, setLoading] = useState(false);
    const [errorIntent, setErrorIntent] = useState(false);
    const [amount, setAmount] = useState(0);

    const {call} = useAuthCalls();

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            await call(
                () => doCreatePaymentIntent(subscription.id, user_id),
                (res) => {
                    if (res.client_secret && res.status === "ok") {
                        setClientSecret(res.client_secret);
                    }
                    if (res.amount !== null) {
                        let num = res.amount / 100;
                        num > 0 && setAmount(parseFloat(num).toFixed(2));
                    }
                },
                (error) => {
                    setErrorIntent(true);
                }
            );
            setLoading(false);
        }

        load();
    }, []);

    const options = {
        clientSecret
    }

    return (
        <div className="flex flex-col items-center">
            <div className="mb-8 w-full">
                <div className="text-2xl text-ea_yellow mb-4">Hai selezionato il seguente prodotto: </div>
                <div className="border-b w-full text-left">
                    <div className="font-bold">{subscription.name}</div>
                    <div>{subscription.description}</div>
                </div>
                {loading ?
                    <Row className="justify-end">
                        <Loading label="Calcolo in corso" className="text-xs"/>
                    </Row>
                    :
                    <div className="font-bold text-right">{amount} €</div>
                }
            </div>

            <div className="mb-8">Inserisci i dati di pagamento per procedere all'acquisto e all'<strong>attivazione istantanea</strong> dell’abbonamento.</div>

            {loading
                ? <Loading/>
                : <div className="text-black">
                    {errorIntent &&
                    <ErrorMessage>Qualcosa è andato storto. Impossibile procedere.</ErrorMessage>
                    }
                    {clientSecret &&
                    <Elements stripe={stripePromise} options={options}>
                        <div className="p-4 rounded bg-gray-200 flex flex-col items-center">
                            <CheckoutForm/>
                        </div>
                    </Elements>}
                </div>
            }
            {!loading &&
            <div className="text-white flex flex-col items-center">
                <div className="my-8">oppure</div>
                <p className="mb-4">
                    Effettua un <strong>bonifico bancario</strong>, l'abbonamento sarà attivato dal nostro staff entro <strong>5 giorni lavorativi.</strong> <br />
                </p>

                <BankTransferData amount={amount}
                                  subscription={subscription}
                                  user={user} />
            </div>
            }
        </div>
    );
};

export default SubscriptionPurchase;